import { render, staticRenderFns } from "./NewType.vue?vue&type=template&id=3a854bfd&"
import script from "./NewType.vue?vue&type=script&lang=js&"
export * from "./NewType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports